import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import Form from "react-bootstrap/Form";
import Badge from "react-bootstrap/Badge";

import { getAreaList } from "../../../API/Lists/area";

const SelectedAreas = ({ selectedAreas, onChangeAreas, onRemoveArea, language = "ES" }) => {
	const styles = {
		cursor: `url(${"https://assets.mydna.company/mydna_trash_icon.svg"}), auto`,
		// otros estilos si es necesario
	};

	const [areaAddedList, setAreaAddedList] = useState([]);

	useEffect(() => {
		const requests = async () => {
			const areaListAux = await getAreaList();
			setAreaAddedList(areaListAux);
		};
		requests();
	}, []);

	return (
		<>
			<div>
				<Form.Select
					value={0}
					name={"areas"}
					onChange={(e) => {
						onChangeAreas(e);
					}}
				>
					<option value={0}>{language === "PT-BR" ? "Selecionar área" : "Seleccionar área"}</option>
					{areaAddedList?.map((ar, key) => {
						return (
							<option key={key} value={ar?.profileArea} data-areaid={ar?.id}>
								{ar?.profileArea}
							</option>
						);
					})}
				</Form.Select>
				<Form.Text className="text-muted">{language === "PT-BR" ? "Pode selecionar mais de uma área" : "Puedes elegir más de un área"}</Form.Text>
			</div>
			<div className="my-2" style={{ maxWidth: "220px" }}>
				{selectedAreas.map((el, index) => {
					return (
						<div
							onClick={() => {
								onRemoveArea(el.area);
							}}
							key={index}
							style={styles}
						>
							<span className={"me-1"}>
								<Badge bg="info">{el.area}</Badge>
							</span>
						</div>
					);
				})}
			</div>
		</>
	);
};

export default SelectedAreas;
